import { render, staticRenderFns } from "./gui_collapse.vue?vue&type=template&id=f9695d96&"
import script from "./gui_collapse.vue?vue&type=script&lang=js&"
export * from "./gui_collapse.vue?vue&type=script&lang=js&"
import style0 from "./gui_collapse.vue?vue&type=style&index=0&id=f9695d96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports